import { openBlock as e, createElementBlock as o, createElementVNode as r } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(T, t) {
  return e(), o("svg", n, [...t[0] || (t[0] = [
    r("path", {
      fill: "currentColor",
      d: "M7 18q-1.65 0-2.825-1.175T3 14t1.175-2.825T7 10t2.825 1.175T11 14t-1.175 2.825T7 18m0-2q.824 0 1.412-.588Q9 14.825 9 14t-.588-1.413A1.93 1.93 0 0 0 7 12q-.824 0-1.412.587A1.93 1.93 0 0 0 5 14q0 .825.588 1.412Q6.175 16 7 16m9.5-2q-2.3 0-3.9-1.6T11 8.5t1.6-3.9T16.5 3t3.9 1.6T22 8.5t-1.6 3.9-3.9 1.6m-2 7a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 11.5 18q0-1.25.875-2.125A2.9 2.9 0 0 1 14.5 15q1.25 0 2.125.875T17.5 18t-.875 2.125A2.9 2.9 0 0 1 14.5 21m2-9q1.475 0 2.488-1.012T20 8.5t-1.012-2.488Q17.975 5 16.5 5t-2.488 1.012T13 8.5t1.012 2.488T16.5 12m-2 7a.97.97 0 0 0 .713-.288A.97.97 0 0 0 15.5 18a.97.97 0 0 0-.287-.712A.97.97 0 0 0 14.5 17a.97.97 0 0 0-.712.288.97.97 0 0 0-.288.712q0 .424.288.712A.97.97 0 0 0 14.5 19"
    }, null, -1)
  ])]);
}
const a = { render: l };
export {
  a as default,
  l as render
};
